import React from 'react';

import {
  Container,
  GetToKnowBackgroundContainer,
  GetToKnowContent,
  GetToKnowContainer,
  OurValuesContainer,
  OurValuesContent,
  TeamContainer,
  TeamContent,
  TeamList,
} from './styles';

import Aribert from '../../assets/team/aribert.png';
import Carol from '../../assets/team/carol.png';
import Eudes from '../../assets/team/eudes.png';
import Junior from '../../assets/team/jr.png';
import Mayron from '../../assets/team/mayron.png';

import TeamPeople from './TeamPeople';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ImageHeader from '../../components/ImageHeader';

const AboutUs: React.FC = () => {
  return (
    <>
      <Header />

      <ImageHeader title="SOBRE NÓS" goToDiv="about-us" />

      <Container id="about-us">
        <GetToKnowBackgroundContainer>
          <GetToKnowContainer>
            <GetToKnowContent>
              <span>SAIBA</span>
              <h1>
                QUEM
                <br />
                SOMOS
              </h1>
              <p>
                A Karbon surgiu em 2018 de uma pequena ideia de fornecer
                serviços de modelagem 3D e Design. No mesmo ano, tivemos nosso
                primeiro contato com desenvolvimento de jogos participando da
                Global Game Jam, descobrindo então nossa verdadeira paixão.
                <br />
                <br />
                Em 2019 participamos da Game Jam Plus e vencemos a Etapa
                Regional, tendo a oportunidade de participar da final
                internacional que foi realizada no Rio de Janeiro.
                <br />
                <br />
                Desde então damos continuidade em nossa jornada, tendo o
                objetivo de compartilhar nossas experiências e proporcionar
                incríveis aventuras no futuro. Vamos juntos?
              </p>
            </GetToKnowContent>
          </GetToKnowContainer>
        </GetToKnowBackgroundContainer>

        <OurValuesContainer>
          <OurValuesContent>
            <h1>NOSSA PROPOSTA</h1>
            <p>
              Buscamos desenvolver e aperfeiçoar jogos com temáticas diversas e
              de fácil acesso pelo público. Com foco em proporcionar novas
              experiências, nossa proposta gira em torno de promover diversão,
              educação e conexão social.
            </p>
          </OurValuesContent>
        </OurValuesContainer>

        <TeamContainer>
          <TeamContent>
            <h1>A EQUIPE</h1>
            <TeamList>
              <TeamPeople
                name="Mayron Oliveira"
                prole="3D ARTIST /ANIMATOR"
                image={Mayron}
              />
              <TeamPeople
                name="Ana Caroline"
                prole="3D ARTIST /ANIMATOR"
                image={Carol}
              />
              <TeamPeople
                name="Aribert Seilá"
                prole="3D ARTIST /ANIMATOR"
                image={Aribert}
              />
              <TeamPeople
                name="Eudes Tenório"
                prole="PROGRAMADOR FULL STACK"
                image={Eudes}
              />
              <TeamPeople
                name="Junior Motta"
                prole="3D ARTIST /ANIMATOR"
                image={Junior}
              />
              <TeamPeople
                name="Anderson Rafhael"
                prole="3D ARTIST /ANIMATOR"
                image={Mayron}
              />
              <TeamPeople
                name="Mayron “MYRN” OLIVEIRA"
                prole="3D ARTIST /ANIMATOR"
                image={Mayron}
              />
            </TeamList>
          </TeamContent>
        </TeamContainer>
      </Container>

      <Footer />
    </>
  );
};

export default AboutUs;
